export const initialDataState = {
  sort: [
    {
      field: "code",
      dir: "asc",
    },
  ],
};

export const formDefaultValues = {
  cashCenterId: null,
  officeId: "",
  description: "",
  assetType: "",
  assetNo: "",
  serialNo: "",
  model: "",
  brand: "",
  status: "",
  remarks: "",
};
